import { Music, Cpu, Activity, Zap } from 'lucide-react'

const APP_VERSION = '2.0.0'
import { useEffect, useState } from 'react'
import { getSystemStatus, type SystemStatus } from '../lib/api'

export function Header() {
  const [status, setStatus] = useState<SystemStatus | null>(null)

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const data = await getSystemStatus()
        setStatus(data)
      } catch {
        console.error('Failed to fetch status')
      }
    }

    fetchStatus()
    const interval = setInterval(fetchStatus, 10000)
    return () => clearInterval(interval)
  }, [])

  return (
    <header className="sticky top-0 z-50 border-b border-white/5 bg-surface-950/80 backdrop-blur-xl">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-3">
            <div className="relative">
              <div className="absolute inset-0 bg-primary-500/20 blur-xl rounded-full"></div>
              <div className="relative bg-gradient-to-br from-primary-500 to-primary-600 p-2.5 rounded-xl shadow-lg shadow-primary-500/25">
                <Music className="w-5 h-5 text-white" />
              </div>
            </div>
            <div>
              <h1 className="text-lg font-bold text-white">
                GPU Stem Separation
                <span className="ml-2 text-[10px] font-normal text-gray-500 align-middle">v{APP_VERSION}</span>
              </h1>
              <p className="text-xs text-gray-500 hidden sm:block">Multi-GPU Audio Processing</p>
            </div>
          </div>

          {status && (
            <div className="flex items-center gap-2 sm:gap-3">
              <div className={`status-badge ${
                status.gpu_available ? 'status-success' : 'status-error'
              }`}>
                <Cpu className="w-3.5 h-3.5" />
                <span className="hidden sm:inline">
                  {status.gpu_count} GPU{status.gpu_count !== 1 ? 's' : ''}
                </span>
                <span className="sm:hidden">{status.gpu_count}</span>
              </div>
              
              <div className={`status-badge ${
                status.active_jobs > 0 ? 'status-warning' : 'status-neutral'
              }`}>
                {status.active_jobs > 0 ? (
                  <>
                    <Activity className="w-3.5 h-3.5 animate-pulse" />
                    <span>{status.active_jobs} active</span>
                  </>
                ) : (
                  <>
                    <Zap className="w-3.5 h-3.5" />
                    <span className="hidden sm:inline">Idle</span>
                  </>
                )}
              </div>

              <div className="hidden md:flex status-badge status-info">
                <span>{status.total_samples_processed.toLocaleString()} processed</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
